/* Presentation enhancements only. Parallax owns variants, media and cart mutations. */
(() => {
  const menus = new WeakSet();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
  }, { threshold: 0.08 }) : null;
  function init(scope = document) {
    scope.querySelectorAll('[data-lux-reveal]').forEach(el => {
      if (observer && !reducedMotion.matches && !window.Shopify?.designMode) { el.classList.add('lux-will-reveal'); observer.observe(el); }
    });
    scope.querySelectorAll('[data-lux-menu]').forEach(menu => {
      if (menus.has(menu)) return;
      menus.add(menu);
      const trigger = menu.querySelector('summary');
      const close = (restore = true) => { menu.open = false; if (restore) trigger.focus(); };
      trigger.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(menu.open));
        document.documentElement.classList.toggle('lux-menu-open', menu.open);
        document.querySelectorAll('#content_wrapper, .lux-wordmark, .lux-header__utilities, .lux-header > .lr-department-switcher').forEach(el => el.inert = menu.open);
        if (menu.open) menu.querySelector('[data-lux-close]').focus();
      });
      menu.querySelector('[data-lux-close]').addEventListener('click', () => close());
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close(false)));
      menu.addEventListener('keydown', event => {
        if (!menu.open) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          const stops = [...menu.querySelectorAll('summary, a[href], button')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
          const first = stops[0], last = stops.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
    });
  }
  // Use the existing drawer when it has initialized; otherwise the cart URL remains usable.
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-lux-cart]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const api = window.jQuery?.('#cart').data('mmenu');
    if (api?.open) { event.preventDefault(); api.open(); }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-lux-reveal]').forEach(el => observer?.unobserve(el));
    if (event.target.querySelector('[data-lux-menu][open]')) { document.documentElement.classList.remove('lux-menu-open'); document.querySelectorAll('#content_wrapper, .lux-wordmark, .lux-header__utilities, .lux-header > .lr-department-switcher').forEach(el => el.inert = false); }
  });
  document.addEventListener('shopify:block:select', event => {
    const disclosure = event.target.closest('.lux-disclosure');
    if (disclosure) disclosure.open = true;
  });
  init();
})();

